/**
 * Utilidades para detectar el estado de instalación de la PWA
 */

// Función mejorada para detectar si la PWA está instalada
export function checkIfPWAInstalled() {
  // Verificar que estamos en un entorno de navegador
  if (typeof window === 'undefined') return false
  
  // Método 1: Verificar display-mode standalone (más confiable)
  const isStandaloneMode = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches
  
  // Método 2: Verificar si está en modo standalone de iOS (navigator.standalone)
  const isIOSStandalone = window.navigator.standalone === true
  
  // Método 3: Verificar si está en modo fullscreen (iOS)
  const isFullscreen = window.matchMedia && window.matchMedia('(display-mode: fullscreen)').matches
  
  // Método 4: Verificar si está en modo minimal-ui (Android)
  const isMinimalUI = window.matchMedia && window.matchMedia('(display-mode: minimal-ui)').matches
  
  // Método 5: Verificar si está en modo browser pero con características de PWA
  // Solo considerar esto si hay evidencia clara de que fue instalada desde PWA
  const isPWAInBrowser = window.matchMedia && window.matchMedia('(display-mode: browser)').matches && 
                        window.location.search.includes('source=pwa')
  

  
  // Considerar instalada solo si cumple criterios más estrictos
  // Priorizar los métodos más confiables
  const isInstalled = isStandaloneMode || isIOSStandalone || isFullscreen || isMinimalUI || isPWAInBrowser
  

  
  return isInstalled
}

// Función para verificar si la PWA puede ser instalada
export function canInstallPWA() {
  // Verificar que estamos en un entorno de navegador
  if (typeof window === 'undefined') return false
  
  // Verificar que no esté ya instalada
  if (checkIfPWAInstalled()) return false
  
  // Verificar que sea un dispositivo móvil
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                   ('ontouchstart' in window && window.innerWidth < 768)
  
  if (!isMobile) return false
  
  // Verificar que tenga soporte para service workers
  if (!('serviceWorker' in navigator)) return false
  
  // Verificar que tenga soporte para beforeinstallprompt
  // Esto se verifica dinámicamente cuando se dispara el evento
  
  return true
}

// Función para obtener el tipo de instalación actual
export function getInstallationType() {
  if (typeof window === 'undefined') return 'unknown'
  
  if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
    return 'standalone'
  }
  
  if (window.matchMedia && window.matchMedia('(display-mode: fullscreen)').matches) {
    return 'fullscreen'
  }
  
  if (window.matchMedia && window.matchMedia('(display-mode: minimal-ui)').matches) {
    return 'minimal-ui'
  }
  
  if (window.navigator.standalone === true) {
    return 'ios-standalone'
  }
  
  if (window.matchMedia && window.matchMedia('(display-mode: browser)').matches) {
    return 'browser'
  }
  
  return 'unknown'
}

// Función para escuchar cambios en el estado de instalación
export function onInstallationChange(callback) {
  if (typeof window === 'undefined') return () => {}
  
  const handleChange = () => {
    const isInstalled = checkIfPWAInstalled()
    callback(isInstalled)
  }
  
  // Escuchar cambios en el modo de visualización
  if (window.matchMedia) {
    const mediaQuery = window.matchMedia('(display-mode: standalone)')
    mediaQuery.addEventListener('change', handleChange)
  }
  
  // Escuchar evento de instalación
  window.addEventListener('appinstalled', handleChange)
  
  // Retornar función de limpieza
  return () => {
    if (window.matchMedia) {
      const mediaQuery = window.matchMedia('(display-mode: standalone)')
      mediaQuery.removeEventListener('change', handleChange)
    }
    window.removeEventListener('appinstalled', handleChange)
  }
} 